import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import DeviceTargeting from './DeviceTargeting';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  campaignId: string | undefined;
  onChange: (targeting: TargetingBaseType) => void;
  sessionId: string;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function DeviceTargetingWrapper({ campaignId, onChange, sessionId, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <DeviceTargeting campaignId={campaignId} sessionId={sessionId} />
    </TargetingProvider>
  );
}

export default DeviceTargetingWrapper;
